import columns from '../../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    DateTimeColumn,
    ExternalReceptacleLinkColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Origin operator', 'originOperator'),
        new TextColumn('Destination operator', 'destinationOperator'),
        new ExternalReceptacleLinkColumn(new TextColumn('Receptacle ID', 'receptacleId').withWidth(300)),
        new TextColumn('Origin country', 'originCountry'),
        new TextColumn('Destination country', 'destinationCountry'),
        new DateTimeColumn('Despatch closed', 'despatchCloseDate'),
        new NonZeroNumberColumn('Items', 'items'),
        new TextColumn('Items with handover data', 'handoverData'),
        new TextColumn('MRD POD', 'mrd'),
        new TextColumn('R21 or R23', 'r21or23'),
        new TextColumn('RESCON', 'rescon'),
        new TextColumn('CARDIT', 'cardit'),
        new TextColumn('PRECON', 'precon'),
        new TextColumn('In MRD scan file', 'inMrdScanFile'),
      ],
    },
  ];
};
